import type { HTMLAttributes, ReactNode } from "react";

export type BadgeTone = "default" | "success" | "warning" | "danger" | "info" | "gold";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  dot?: boolean;
  children?: ReactNode;
}

const toneClass: Record<BadgeTone, string> = {
  default: "",
  success: "fd-badge--success",
  warning: "fd-badge--warning",
  danger: "fd-badge--danger",
  info: "fd-badge--info",
  gold: "fd-badge--gold",
};

export function Badge({ tone = "default", dot = true, className, children, ...rest }: BadgeProps) {
  const cls = ["fd-badge", toneClass[tone], className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {dot && <span className="fd-badge__dot" />}
      {children}
    </span>
  );
}
